module.exports = __webpack_public_path__ + "images/h4_smallc409f557b843a1917a9791b331e0f72c.png";